import { Observable } from 'rxjs';
import { Message, ReportStatusUpdate, ValidationUpdate } from '../models/message.model';

export type RealtimeConnectionState = 'connected' | 'connecting' | 'disconnected';

export abstract class ChatRealtimePort {
  abstract incoming$: Observable<Message>;
  abstract validationUpdates$: Observable<ValidationUpdate>;
  abstract reportStatusUpdates$: Observable<ReportStatusUpdate>;
  abstract connection$: Observable<RealtimeConnectionState>;
  abstract typing$: Observable<boolean>;
  abstract sendMessage(
    chatId: string | number,
    clientMessageId: string,
    text: string
  ): void;
  abstract sendImage(
    chatId: string | number,
    clientMessageId: string,
    mediaUrl: string
  ): void;
  abstract connect(): void;
  abstract disconnect(): void;
}
